import { createSelector } from 'reselect'
import { sum } from 'lib/array/arrayUtils'
import getLoyaltyPurchasePointsItemViews from '../view/itemViews/getLoyaltyPurchasePointsItemViews'

const getLoyaltyPurchasePointsTotals = createSelector(
  (state: App.State) => getLoyaltyPurchasePointsItemViews(state),
  (viewWithStatus): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    return {
      hasRequiredData: viewWithStatus.hasRequiredData,
      data: {
        price: sum(viewWithStatus.data, view => view.totals.price),
        memberPrice: 0,
        value: sum(viewWithStatus.data, view => view.totals.value),
        memberValue: 0,
        surcharge: 0,
        extraGuestSurcharge: 0,
        taxesAndFees: 0,
      },
    }
  },
)

export default getLoyaltyPurchasePointsTotals
